import MarkerProps from "./markerProps"
import { markerSizes } from "./markerSizes"

const LocationMarker = ({
  size = 'medium',
}:MarkerProps) => {

  return (
    <svg width={markerSizes[size].width} height={markerSizes[size].height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="8" fill="#007AFF"/>
    <circle cx="18" cy="18" r="15" stroke="#007AFF" stroke-opacity="0.5" stroke-width="5"/>
    </svg>

  )
}

export default LocationMarker
